import { Module } from '@nestjs/common';
import { SalesService } from './sales.service';
import { SalesController } from './sales.controller';
import { SaleAttachmentsEntity, SalesEntity, UsersEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GuardsModule } from '../guards/guards.module';
import { SupabaseModule } from '../supabase/supabase.module';

@Module({
  controllers: [SalesController],
  providers: [SalesService],
  imports: [
    TypeOrmModule.forFeature([SalesEntity, SaleAttachmentsEntity, UsersEntity]),
    GuardsModule,
    SupabaseModule
  ],
})
export class SalesModule {}
